.svg{height:9rem}.svg--medium{height:13.5rem}.svg--large{height:18rem}.seconds{display:flex;align-items:center}
/*# sourceMappingURL=digital-clock.component-XBMPXVA3.css.map */
